export interface Bonus {
  title: string
  description: string
  price: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Math Flashcards Pack',
    description: 'Printable drills for every operation',
    price: '$27',
    image: 'https://cdn.magicpatterns.com/uploads/5J1Sbmz3bUP9Q5iCLd8LFd/m11.webp',
  },
  {
    title: 'The Ultimate Teacher Guide',
    description: 'Worked solutions and full answer keys',
    price: '$19',
    image: 'https://cdn.magicpatterns.com/uploads/gDRQEy7kwtFKU2VZpUhopf/m1.webp',
  },
  {
    title: 'Progress Tracker & Certificates',
    description: 'Sheets to record every Quick Check',
    price: '$17',
    image: 'https://cdn.magicpatterns.com/uploads/8pbZqdhJ5YQn2Qh4wFm15u/m2.webp',
  },
  {
    title: 'Math Games & Puzzles',
    description: 'Practice that feels like play',
    price: '$15',
    image: 'https://cdn.magicpatterns.com/uploads/aazmft4isgaop5WBhqqpHf/m4.webp',
  },
  {
    title: 'Real-World Math Projects',
    description: 'Hands-on projects with rubrics',
    price: '$19',
    image: 'https://cdn.magicpatterns.com/uploads/9bMkKTtgi6ckJr2TZT4DDb/m5.webp',
  },
]
